import { render, staticRenderFns } from "./Administradores.vue?vue&type=template&id=c3f5c40e&scoped=true"
import script from "./Administradores.vue?vue&type=script&lang=js"
export * from "./Administradores.vue?vue&type=script&lang=js"
import style0 from "./Administradores.vue?vue&type=style&index=0&id=c3f5c40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5c40e",
  null
  
)

export default component.exports